export default __webpack_public_path__ + "static/media/landing-visitor-icon.767549c0.svg";